import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateSmsDripSequence as UpdateSmsDripSequenceMutation,
    UpdateSmsDripSequenceVariables,
    SmsDripSequenceUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_SMS_DRIP_SEQUENCE from '../mutations/update-sms-drip-sequence.graphql';
import GET_SMS_DRIP_SEQUENCE from '../queries/get-sms-drip-sequence.graphql';

export const useUpdateSmsDripSequence = (): {
    updateSmsDripSequence: (arg1: SmsDripSequenceUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateSmsDripSequence, {loading, error}] = useMutation<
        UpdateSmsDripSequenceMutation,
        UpdateSmsDripSequenceVariables
    >(UPDATE_SMS_DRIP_SEQUENCE);

    return {
        updateSmsDripSequence: (input: SmsDripSequenceUpdateInput) =>
            updateSmsDripSequence({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const updatedDripSequence =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.smsDripSequenceUpdate &&
                        mutationResults.data.smsDripSequenceUpdate.campaign;

                    if (!updatedDripSequence) return;

                    const cachedData = proxy.readQuery({
                        query: GET_SMS_DRIP_SEQUENCE,
                        variables: {dripSequenceId: updatedDripSequence.id},
                    });

                    if (cachedData) {
                        // @ts-expect-error
                        const cachedDripSequence = cachedData.smsDripSequence;

                        proxy.writeQuery({
                            query: GET_SMS_DRIP_SEQUENCE,
                            variables: {dripSequenceId: updatedDripSequence.id},
                            data: {
                                smsDripSequence: {
                                    // @ts-expect-error
                                    ...cachedData.smsDripSequence,
                                    name: updatedDripSequence.name,
                                    edition: {
                                        ...cachedDripSequence,
                                        ...updatedDripSequence,
                                    },
                                },
                            },
                        });
                    }
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
